// Carries only a fixed placement label through the Pepperstone information page.
// No identifiers, cookies, storage, analytics events or network requests are used.
const origin = 'https://www.pineconnector.com';
const defaultDestination = `${origin}/broker/pepperstone-page`;
const placements = new Map([
  ['docs-start', `${origin}/broker/docs-start`],
  ['docs-install', `${origin}/broker/docs-install`],
  ['pepperstone-page', defaultDestination],
  ['blog-pepperstone', `${origin}/broker/blog-pepperstone`],
  ['blog-mt5', `${origin}/broker/blog-mt5`],
  ['blog-strategy', `${origin}/broker/blog-strategy`],
  ['website-footer', `${origin}/broker/website-footer`],
  ['qa', `${origin}/broker/qa`],
]);

export function placementDestination(search) {
  if (typeof search !== 'string') return defaultDestination;
  const sources = new URLSearchParams(search).getAll('pc_ref');
  return sources.length === 1 ? placements.get(sources[0]) || defaultDestination : defaultDestination;
}

export function bindPlacementLinks(doc, search) {
  const destination = placementDestination(search);
  for (const link of doc.querySelectorAll('a[data-pc-broker-link]')) {
    // Limit this helper to the deliberately marked default referral action.
    if (link.getAttribute('href') === defaultDestination) link.setAttribute('href', destination);
  }
}

if (typeof document !== 'undefined' && typeof location !== 'undefined') {
  bindPlacementLinks(document, location.search);
}
